import {
  createContext,
  useContext,
  ReactNode,
  useState,
  FC,
} from "react";

import { FormatDateDayLastMonth } from "src/shared/Utils/FormatDate/FormatDateDayLastMonth";
import { IFilterHome, IFilterGraphicProduction, IMetricsContextType, IValuesBalancePiesADM, IValuesBalancePiesModalidade, IValuesBalancePiesOperadora, IValuesCardsBalancesHome, IValuesCardsInstallmentsHome, IValuesCardsTopsProducersHome, IValuesGraphicProduction } from "./ContextMetricsTypes";
import { FormatDateFirstDayYear } from "src/shared/Utils/FormatDate/FormatDateFirstDayYear";
import { GetDateUSSemValue } from "src/shared/Utils/FormatDateBR";

const MetricsContext = createContext({} as IMetricsContextType);

export const MetricsContextProvider: FC<{ children: ReactNode }> = ({ children, }) => {
  const [valuesCardsBalancesHome, setValuesCardsBalancesHome] = useState<IValuesCardsBalancesHome>();
  const [valuesCardsInstallmentsHome, setValuesCardsInstallmentsHome] = useState<IValuesCardsInstallmentsHome>();
  const [valuesCardsTopsProducersHome, setValuesCardsTopsProducersHome] = useState<IValuesCardsTopsProducersHome>();
  const [valuesBalancePiesADM, setValuesBalancePiesADM] = useState<IValuesBalancePiesADM[]>([]);
  const [valuesBalancePiesOperadora, setValuesBalancePiesOperadora] = useState<IValuesBalancePiesOperadora[]>([]);
  const [valuesBalancePiesModalidade, setValuesBalancePiesModalidade] = useState<IValuesBalancePiesModalidade[]>([]);

  const [dataGraphicProduction, setDataGraphicProduction] = useState<IValuesGraphicProduction>({
    data: [{ label: "", value: 0 }],
  });


  const [filterHome, setFilterHome] = useState<IFilterHome>({
    startDate: FormatDateDayLastMonth().firstDayMonth,
    endDate: FormatDateDayLastMonth().lastDayMonth,
    tipo_contrato: "ALL",
  });

  const [filterGraphicProduction, setFilterGraphicProduction] = useState<IFilterGraphicProduction>({
    start_date: FormatDateFirstDayYear(),
    end_date: GetDateUSSemValue(),
    interval: "MONTH",
  });

  return (
    <MetricsContext.Provider
      value={{
        setFilterGraphicProduction,
        filterGraphicProduction,
        setDataGraphicProduction,
        dataGraphicProduction,
        setValuesCardsTopsProducersHome,
        valuesCardsTopsProducersHome,
        setValuesCardsInstallmentsHome,
        valuesCardsInstallmentsHome,
        setValuesCardsBalancesHome,
        valuesCardsBalancesHome,
        setValuesBalancePiesADM,
        valuesBalancePiesADM,
        setValuesBalancePiesOperadora,
        valuesBalancePiesOperadora,
        setValuesBalancePiesModalidade,
        valuesBalancePiesModalidade,
        setFilterHome,
        filterHome,
      }}
    >
      {children}
    </MetricsContext.Provider>
  );
};

export const useMetricsContext = (): IMetricsContextType => useContext(MetricsContext);
